import { IVendor, IVendorData } from '../vendor.types';
import { Vendor } from '../vendor';

export const mockVendorsData = (): IVendorData[] => [
  {
    id: 'C400001',
    name: '407 ETR',
    category: 'TRAVEL',
    address1: 'ETR - 407 EXPRESS TOLL ROUTE',
    address2: 'P.O. BOX 407, STATION D',
    address3: '',
    address4: '',
    city: 'SCARBOROUGH',
    region: 'ON',
    postal_code: 'M1R 5J8',
    country: 'CANADA',
    currency: 'CAD',
    status: 'A',
    terms: 'DI',
    terms_description: 'Due Immediately',
    language: '',
    contact: '',
    phone: '888 407 0407',
    email: '',
    manually_created: false
  },
  {
    id: 'C210001',
    name: '2190453 Ontario Inc.',
    category: '',
    address1: '30 FLEMING DRIVE UNIT 5',
    address2: '',
    address3: '',
    address4: '',
    city: 'CAMBRIDGE',
    region: 'ON',
    postal_code: 'N1T 2B1',
    country: 'CANADA',
    currency: 'CAD',
    status: 'A',
    terms: 'N30',
    terms_description: 'Net 30 Days',
    language: '',
    contact: '',
    phone: '519-740-8938',
    email: '',
    manually_created: false
  }
];

export const mockVendors = (
  data: IVendorData[] = mockVendorsData()
): IVendor[] => data.map(item => new Vendor(item));
